import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MapService } from '../../shared/services/Map.service';
import { MapHelperService } from '../../../../services/map-helper.service';
import { RouteFilterService } from './Route-Filter.service';

@Injectable({
  providedIn: "root",
})
export class RouteMapService {
  
  public Result;
  httpHeaders: HttpHeaders = new HttpHeaders();
  private isLoading: boolean = false;
  private isLoading$: Subject<boolean> = new Subject();
  
  constructor(
    private mapService: MapService,
    private mapHelperService: MapHelperService,
    private routeFilterService: RouteFilterService
    ) {
  }

  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }

  hiddenRouteMapLayers(){
    this.mapHelperService.HideLayer("routeResume-steps-textlayer");
    this.mapHelperService.HideLayer("routeResume-line-layer");
    this.mapHelperService.HideLayer("routeResume-steps-layer");
    this.mapHelperService.HideLayer("routeResume-lineOpacityMin-layer");
    this.mapHelperService.HideLayer("routeStepsGroup-line-layer");
    this.mapHelperService.HideLayer("routeStepsGroup-steps-textlayer");
  }

  showRouteMapLayers() {
    this.mapHelperService.ShowLayer("routeResume-steps-textlayer");
    this.mapHelperService.ShowLayer("routeResume-line-layer");
    this.mapHelperService.ShowLayer("routeResume-steps-layer");
    this.mapHelperService.ShowLayer("routeResume-lineOpacityMin-layer");
    this.mapHelperService.ShowLayer("routeStepsGroup-line-layer");
    this.mapHelperService.ShowLayer("routeStepsGroup-steps-textlayer");
  }

  updateRouteMap(result: string) {
   // Actualiza capa de Puntos Inicio y Fin
   this.mapService.UpdateLayerGeoJson(
     "routeResume",
     JSON.parse(result)
   );
   this.mapService.UpdateLayerGeoJson(
     "routeResumeOpacityMin",
     JSON.parse(result)
   );
  
  
   // Setea el centro de la cámara
   this.mapHelperService.ClearLayerActive();
  }

  deleteRoutesData() {
    this.mapHelperService.UpdateLayerGeoJson("routeResume-line-layer",this.mapHelperService.Empty_GeoJson);
    this.mapHelperService.UpdateLayerGeoJson("routeResume-lineOpacityMin-layer",this.mapHelperService.Empty_GeoJson);
    this.mapHelperService.UpdateLayerGeoJson("routeGroupStep",this.mapHelperService.Empty_GeoJson);
    this.mapService.UpdateLayerGeoJson("routeResume",this.mapHelperService.Empty_GeoJson);
    this.mapService.UpdateLayerGeoJson("routeResumeOpacityMin",this.mapHelperService.Empty_GeoJson);
  }


 
  
}
